module.exports = __webpack_public_path__ + "img/article_bg.a5b85e0f.png";